import { Organization, Site } from './organization.model';

export interface ApiPaginatedResponse<T> {
  data: T[];
  meta: {
    page: number;
    per_page: number;
    total: number;
    results_count: number;
  };
}

export interface ApiOrgResponse {
  id: string;
  display_labels: Record<string, string>;
}

export interface ApiSiteResponse {
  id: string;
  ref: string;
  parent_id: string;
  display_labels: Record<string, string>;
  organization_id: string;
}

const DEFAULT_LABEL = 'en_US';

function getDisplayLabel(displayLabels: Record<string, string>): string {
  return displayLabels[DEFAULT_LABEL] ?? Object.values(displayLabels)[0] ?? '';
}

export function mapApiOrg(apiOrg: ApiOrgResponse): Organization {
  return {
    id: apiOrg.id,
    name: getDisplayLabel(apiOrg.display_labels),
  };
}

export function mapApiSite(apiSite: ApiSiteResponse): Site {
  return {
    id: apiSite.id,
    name: getDisplayLabel(apiSite.display_labels),
    organizationId: apiSite.organization_id,
  };
}
